import "../../scss/components/_modal.scss";

const openModalTriggers = document.querySelectorAll('.js-open-modal');
const closeModalTriggers = document.querySelectorAll('.js-close-modal');
const modals = document.querySelectorAll('.modal');
const newsletterForm = document.querySelector('.newsletter__form');

// Open modal
document.addEventListener('click', (e) => {
    const target = e.target;

    if (target.classList.contains('js-open-modal')) {
        e.preventDefault();

        const isInsideNewsletterForm = newsletterForm.contains(target);

        if (isInsideNewsletterForm) {
            const emailInput = document.querySelector('.newsletter__input');
            const gdprCheckbox = document.querySelector('.newsletter__newsletter__checkbox');
            const newsletterError = document.querySelector('.newsletter__error');

            if (emailInput.value.trim() !== '' && gdprCheckbox.checked) {
                const modalId = target.dataset.modal;
                openModal(modalId);
                newsletterError.classList.add('hidden');
            } else {
                newsletterError.classList.remove('hidden');
            }
        } else {
            const modalId = target.dataset.modal;
            openModal(modalId);
        }
    }
});

const openModal = (modalId) => {
    for (const modal of modals) {
        if (modal.dataset.modal === modalId) {
            modal.classList.add('modal--visible');
            document.querySelector('body').classList.add('noscroll');
        }
    }
}

// Close modal
for (const closeModalTrigger of closeModalTriggers) {
    closeModalTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = e.target.dataset.modal;
        closeModal(modalId);
    });
}

const closeModal = (modalId) => {
    for (const modal of modals) {
        if (modal.dataset.modal === modalId) {
            modal.classList.remove('modal--visible');
            document.querySelector('body').classList.remove('noscroll');
        }
    }
}


let BackGeneralPopups = document.querySelectorAll('.back_general_popup'),
    generalPopup = document.querySelector('.modal[data-modal="cancerinfoGeneral"]'),
    contactPopupBtns = document.querySelectorAll('.contactPopup'),
    contactPopup = document.querySelector('.modal[data-modal="cancerinfoContact"]'),
    callbackPopupBtns = document.querySelectorAll('.callbackPopup'),
    callbackPopup = document.querySelector('.modal[data-modal="cancerinfoCallback"]');

for (const BackGeneralPopup of BackGeneralPopups) {
    BackGeneralPopup.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = e.target.dataset.modal;
        closeModal(modalId);

        if (generalPopup) {
            generalPopup.classList.add('modal--visible');
            document.querySelector('body').classList.add('noscroll');
        }
    });
}

for (const contactPopupBtn of contactPopupBtns) {
    contactPopupBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = e.target.dataset.modal;
        closeModal(modalId);

        contactPopup.classList.add('modal--visible');
        document.querySelector('body').classList.add('noscroll');
    });
}

for (const callbackPopupBtn of callbackPopupBtns) {
    callbackPopupBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = e.target.dataset.modal;
        closeModal(modalId);

        callbackPopup.classList.add('modal--visible');
        document.querySelector('body').classList.add('noscroll');
    });
}

// Open popup cancerInfo Contact
let cancerinfoContactModal = document.querySelector('.modal[data-modal="cancerinfoContact"]');
let cancerinfoContactLinks = document.querySelectorAll('.cancerinfo_contact_open-modal');

cancerinfoContactLinks.forEach(link => {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        cancerinfoContactModal.classList.add('modal--visible');
        document.querySelector('body').classList.add('noscroll');
    });
});

document.querySelectorAll('a[href="#cancerinfoContactOpenModal"]').forEach(link => {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        cancerinfoContactModal.classList.add('modal--visible');
        document.querySelector('body').classList.add('noscroll');
    });
});

// Open popup cancerInfo Call me back
let cancerinfoCallbackModal = document.querySelector('.modal[data-modal="cancerinfoCallback"]');

document.querySelectorAll('a[href="#cancerinfoCallbackOpenModal"]').forEach(link => {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        cancerinfoCallbackModal.classList.add('modal--visible');
        document.querySelector('body').classList.add('noscroll');
    });
});
